import { Card, Tag, Text } from "components/common"
import { IconText } from "components/custom"
import styles from "../../index.module.less"
import { Flex } from "antd"

const BestTimeCard = ({ title, description, bestTime, loading }) => {
  return (
    <Card
      bodyStyle={{
        padding: "14px",
        background: "linear-gradient(to right, rgba(0,177,210,0.1), rgba(108,84,163,0.1))",
      }}
      className={styles.basicCard}
      loading={loading}
    >
      <Flex gap={8}>
        <IconText
          block
          textType="secondaryLight"
          icon="FaWandMagicSparkles"
          iconProps={{ color: "#0091BA" }}
          title={
            <>
              <span className="bold" style={{ color: "black" }}>
                {title}
              </span>
            </>
          }
        />
        <Tag
          type="light"
          style={{
            padding: "4px",
            color: "#0091BA",
            background: "linear-gradient(to right, rgba(0,177,210,0.12), rgba(108,84,163,0.12))",
          }}
        >
          <span style={{ fontWeight: "bold", padding: "10px" }}>{bestTime}</span>
        </Tag>
      </Flex>
      <Text type="secondary">{description}</Text>
    </Card>
  )
}

export default BestTimeCard
